import PropTypes from 'prop-types';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import styled from 'styled-components';
import {COLORS} from '../../constants';

const Label = styled.p`
  color: ${COLORS.MAIN_PINK};
`;

const DisplayInfo = ({label, value}) => {
  return (
    <Container>
      <Row>
        <Col>
          <Label>{label}</Label>
        </Col>
        <Col>
          <p>{value}</p>
        </Col>
      </Row>
    </Container>
  );
};

DisplayInfo.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default DisplayInfo;
